<div class="flex-1 flex flex-col">
    <div class="text-xs font-semibold text-gray-800 p-3 cursor-pointer" (click)="goBack()">
        Back
    </div>
</div>
<div class="content-form p-4">
    <div class="bg-gray-100 -mx-4 -mt-4 mb-4">
        <div class="flex items-center p-3 max-w-[1920px] mx-auto">
            <h3 class="text-xs font-semibold text-gray-800">
                Production Data - {{ productName | uppercase}}
            </h3>
        </div>
    </div>
    <div class="max-w-[1920px] mx-auto px-3 grid grid-cols-1 lg:grid-cols-2">
        <div class="items-center lg:pr-6">
            <div class="mb-4">
                <h3 class="text-xs font-bold text-gray-900 w-fit">
                    Printing Details
                </h3>
            </div>
            <div class="grid grid-cols-1 gap-4 mb-4">
                <!-- ── Printing Machine (searchable dropdown) ── -->
                <div class="relative">
                    <input
                            type="text"
                            id="printingMachine"
                            class="input-M peer w-64"
                            placeholder=" "
                            name="printingMachine"
                            [(ngModel)]="printingMachine"
                            (input)="printingMachineDropdownOpen = true"
                            (focus)="printingMachineDropdownOpen = true"
                            (blur)="onPrintingMachineBlur()"
                            autocomplete="off"
                    />
                    <label class="label" for="printingMachine">Printing Machine<span class="text-red-700">*</span></label>

                    <div
                            *ngIf="printingMachineDropdownOpen"
                            class="absolute z-50 w-64 bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"
                    >
                        <div
                                *ngFor="let m of filteredPrintingMachines()"
                                class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"
                                (mousedown)="selectPrintingMachine(m.machineName)"
                        >
                            {{ m.machineName }}
                            <span class="text-gray-400 ml-1">({{ m.capabilities }})</span>
                        </div>
                        <div
                                *ngIf="filteredPrintingMachines().length === 0"
                                class="px-3 py-2 text-xs text-gray-400"
                        >
                            No results
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <div class="relative">
                    <input type="number" id="noOfColors" class="input-M peer w-64" placeholder=" "
                           name="noOfColors"
                           [(ngModel)]="noOfColors">
                    <label class="label" for="noOfColors">No of colors</label>
                </div>
                <div class="relative">
                    <input type="number" id="noOfUps" class="input-M peer w-64" placeholder=" "
                           name="noOfUps"
                           [(ngModel)]="noOfUps">
                    <label class="label" for="noOfUps">No of UPS</label>
                </div>
                <div class="relative">
                    <input type="text" id="proofStandard" class="input-M peer w-64" placeholder=" "
                           name="proofStandard"
                           [(ngModel)]="proofStandard">
                    <label class="label" for="proofStandard">Proof Standard</label>
                </div>
            </div>

            <!-- ── Product Specifications ── -->
            <div class="mb-4" *ngIf="selectedDepartment === 'Flexo' || selectedDepartment === 'Offset'">
                <h3 class="text-xs font-bold text-gray-900 w-fit">
                    Product Specifications
                </h3>
            </div>

            <!-- Flexo -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" *ngIf="selectedDepartment === 'Flexo'">
                <div class="relative">
                    <input type="number" id="widthMm" class="input-M peer w-64" placeholder=" "
                           name="widthMm"
                           [(ngModel)]="widthMm">
                    <label class="label" for="widthMm">Width_mm</label>
                </div>
                <div class="relative">
                    <input type="number" id="lengthMm" class="input-M peer w-64" placeholder=" "
                           name="lengthMm"
                           [(ngModel)]="lengthMm">
                    <label class="label" for="lengthMm">Length_mm</label>
                </div>
                <div class="relative">
                    <input type="number" id="tolerance" class="input-M peer w-64" placeholder=" "
                           name="tolerance"
                           [(ngModel)]="tolerance">
                    <label class="label" for="tolerance">Tolerance</label>
                </div>
                <div class="relative">
                    <input type="number" id="cylinderTeeth" class="input-M peer w-64" placeholder=" "
                           name="cylinderTeeth"
                           [(ngModel)]="cylinderTeeth">
                    <label class="label" for="cylinderTeeth">Cylinder Teeth</label>
                </div>
            </div>

            <!-- Offset -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" *ngIf="selectedDepartment === 'Offset'">
                <div class="relative">
                    <input type="number" id="fullSheetSize" class="input-M peer w-64" placeholder=" "
                           name="fullSheetSize"
                           [(ngModel)]="fullSheetSize">
                    <label class="label" for="fullSheetSize">Full Sheet Size</label>
                </div>
                <div class="relative">
                    <input type="number" id="cutSheetSize" class="input-M peer w-64" placeholder=" "
                           name="cutSheetSize"
                           [(ngModel)]="cutSheetSize">
                    <label class="label" for="cutSheetSize">Cut Sheet Size</label>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" *ngIf="selectedDepartment === 'Offset'">
                <div class="relative">
                    <input type="text" id="offsetWidth" class="input-M peer w-64" placeholder=" "
                           name="offsetWidth"
                           [(ngModel)]="widthMm">
                    <label class="label" for="offsetWidth">Width</label>
                </div>
                <div class="relative">
                    <input type="text" id="offsetLength" class="input-M peer w-64" placeholder=" "
                           name="offsetLength"
                           [(ngModel)]="lengthMm">
                    <label class="label" for="offsetLength">Length</label>
                </div>
                <div class="relative">
                    <input type="number" id="productSize" class="input-M peer w-64" placeholder=" "
                           name="productSize"
                           [(ngModel)]="productSize">
                    <label class="label" for="productSize">Product Size</label>
                </div>
            </div>

            <!-- ── Materials (inventory search, multi-row) ── -->
            <div class="mb-4">
                <h3 class="text-xs font-bold text-gray-900 w-fit">
                    Material Details
                </h3>
            </div>

            <div class="flex gap-4 mb-2 items-center"
                 *ngFor="let m of materials(); let i = index">

                <div class="relative w-full">
                    <input
                            type="text"
                            class="input-M peer w-64"
                            placeholder=" "
                            [name]="'material' + i"
                            [(ngModel)]="materialSearchTerms[i]"
                            (input)="onMaterialInput(i)"
                            (focus)="onMaterialInput(i)"
                            (blur)="onMaterialBlur(i)"
                            autocomplete="off"
                    />
                    <label class="label">Select Material {{ i + 1 }}</label>

                    <div
                            *ngIf="materialDropdownOpen === i"
                            class="absolute z-50 w-64 bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"
                    >
                        <div *ngIf="materialLoading" class="px-3 py-2 text-xs text-gray-400">Searching...</div>
                        <div
                                *ngFor="let item of materialInventoryResults()"
                                class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"
                                (mousedown)="selectMaterial(i, item)"
                        >
                            <span class="font-medium text-gray-800">{{ item.inventoryItemCode }}</span>
                            <span class="text-gray-500 ml-2">{{ item.inventoryItemDescription }}</span>
                        </div>
                        <div *ngIf="!materialLoading && materialInventoryResults().length === 0"
                             class="px-3 py-2 text-xs text-gray-400">
                            No items found
                        </div>
                    </div>
                </div>

                <button
                        type="button"
                        class="h-10 w-10 flex items-center justify-center rounded text-red-600 hover:bg-red-100"
                        (click)="removeMaterial(i)"
                        *ngIf="materials().length > 1"
                        title="Remove material"
                >
                    🗑️
                </button>
            </div>

            <div class="flex justify-between items-center mt-4 mb-6">
                <button
                        type="button"
                        class="button-blue"
                        (click)="addMaterial()"
                >
                    Add Material
                </button>
            </div>

            <div class="mb-4">
                <h3 class="text-xs font-bold text-gray-900 w-fit">
                    Ink Details
                </h3>
            </div>

            <!-- ── Ink (inventory search) ── -->
            <div class="flex gap-4 mb-2 items-center"
                 *ngFor="let ink of inks(); let i = index">

                <div class="relative w-full">
                    <input
                            type="text"
                            class="input-M peer w-64"
                            placeholder=" "
                            [name]="'ink' + i"
                            [(ngModel)]="inkSearchTerms[i]"
                            (input)="onInkInput(i)"
                            (focus)="onInkInput(i)"
                            (blur)="onInkBlur(i)"
                            autocomplete="off"
                    />
                    <label class="label">Select Ink {{ i + 1 }}</label>

                    <div
                            *ngIf="inkDropdownOpen === i"
                            class="absolute z-50 w-64 bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"
                    >
                        <div *ngIf="inkLoading" class="px-3 py-2 text-xs text-gray-400">Searching...</div>
                        <div
                                *ngFor="let item of inkInventoryResults()"
                                class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"
                                (mousedown)="selectInk(i, item)"
                        >
                            <span class="font-medium text-gray-800">{{ item.inventoryItemCode }}</span>
                            <span class="text-gray-500 ml-2">{{ item.inventoryItemDescription }}</span>
                        </div>
                        <div *ngIf="!inkLoading && inkInventoryResults().length === 0"
                             class="px-3 py-2 text-xs text-gray-400">
                            No ink items found
                        </div>
                    </div>
                </div>

                <button
                        type="button"
                        class="h-10 w-10 flex items-center justify-center rounded
                        text-red-600 hover:bg-red-100"
                        (click)="removeInk(i)"
                        *ngIf="inks().length > 1"
                        title="Delete ink"
                >
                    🗑️
                </button>
            </div>

            <div class="flex justify-between items-center mt-4">
                <button
                        type="button"
                        class="button-blue"
                        (click)="addInk()"
                >
                    Add Ink
                </button>
            </div>
        </div>

        <!-- right side -->
        <div class="items-center lg:border-l lg:border-gray-300 lg:pl-6">
            <div class="mb-6">
                <h3 class="text-xs font-bold text-gray-900 w-fit">
                    Finishing Specifications
                </h3>
            </div>

            <!-- ── Finishings (process / machine / remarks) ── -->
            <div class="mb-2">
                <h3 class="text-xs font-bold text-gray-900 w-fit">
                    Finishings
                </h3>
            </div>

            <div class="flex gap-4 mb-2 items-center"
                 *ngFor="let finishing of finishings(); let i = index">

                <!-- Process Dropdown -->
                <div class="relative flex-1">
                    <input
                            type="text"
                            class="input-M peer w-full"
                            placeholder=" "
                            [name]="'process' + i"
                            [(ngModel)]="finishingSearch[i]"
                            (input)="finishingDropdownOpen = i"
                            (focus)="finishingDropdownOpen = i"
                            (blur)="onFinishingBlur(i)"
                            autocomplete="off"
                    />
                    <label class="label">Process</label>

                    <div
                            *ngIf="finishingDropdownOpen === i"
                            class="absolute z-50 w-full bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"
                    >
                        <div
                                *ngFor="let f of filteredFinishings(i)"
                                class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"
                                (mousedown)="selectFinishing(i, f.Finishing)"
                        >
                            {{ f.Finishing }}
                        </div>
                        <div
                                *ngIf="filteredFinishings(i).length === 0"
                                class="px-3 py-2 text-xs text-gray-400"
                        >
                            No results
                        </div>
                    </div>
                </div>

                <!-- Machine Dropdown -->
                <div class="relative flex-1">
                    <input
                            type="text"
                            class="input-M peer w-full"
                            placeholder=" "
                            [name]="'machine' + i"
                            [(ngModel)]="machineSearch[i]"
                            (input)="machineDropdownOpen = i"
                            (focus)="machineDropdownOpen = i"
                            (blur)="onMachineBlur(i)"
                            autocomplete="off"
                    />
                    <label class="label">Machine</label>

                    <div
                            *ngIf="machineDropdownOpen === i"
                            class="absolute z-50 w-full bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"
                    >
                        <div
                                *ngFor="let m of filteredMachines(i)"
                                class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"
                                (mousedown)="selectMachine(i, m.machineName)"
                        >
                            {{ m.machineName }}
                            <span class="text-gray-400 ml-1">({{ m.capabilities }})</span>
                        </div>
                        <div
                                *ngIf="filteredMachines(i).length === 0"
                                class="px-3 py-2 text-xs text-gray-400"
                        >
                            No results
                        </div>
                    </div>
                </div>

                <!-- Remarks -->
                <div class="relative flex-1">
                    <input
                            type="text"
                            class="input-M peer w-full"
                            placeholder=" "
                            [name]="'remarks' + i"
                            [(ngModel)]="finishing.remarks"
                    />
                    <label class="label">Remarks</label>
                </div>

                <!-- Delete -->
                <button
                        type="button"
                        class="h-10 w-10 flex items-center justify-center rounded text-red-600 hover:bg-red-100"
                        (click)="removeFinishing(i)"
                        *ngIf="finishings().length > 1"
                        title="Delete finishing"
                >
                    🗑️
                </button>
            </div>

            <div class="flex justify-between items-center mt-4 mb-6">
                <button
                        type="button"
                        class="button-blue"
                        (click)="addFinishing()"
                >
                    Add Finishing
                </button>
            </div>

            <div class="flex gap-4 mb-2 items-center"
                 *ngFor="let v of varnish(); let i = index">

                <div class="relative w-full">
                    <select
                            id="varnish"
                            name="varnish {{ i }}"
                            class="input-M peer w-64"
                            [(ngModel)]="v.varnish"
                    >
                        <option value="" selected hidden></option>
                        <option value="GLOSS VARNISH">GLOSS VARNISH</option>
                        <option value="MATT VARNISH">MATT VARNISH</option>
                    </select>
                    <label class="label" for="bookCoverType">
                        Select Varnish {{ i + 1 }}
                    </label>
                </div>

                <button
                        type="button"
                        class="h-10 w-10 flex items-center justify-center rounded
                        text-red-600 hover:bg-red-100"
                        (click)="removeVarnish(i)"
                        *ngIf="varnish().length > 1"
                        title="Delete finishing"
                >
                    🗑️
                </button>
            </div>
            <div class="flex justify-between items-center mt-4 mb-6">
                <button
                        type="button"
                        class="button-blue"
                        (click)="addVarnish()"
                >
                    Add Varnish
                </button>
            </div>
            <ng-container *ngIf="selectedDepartment !== 'Offset'">
                <div class="flex gap-4 mb-2 items-center"
                     *ngFor="let v of screens(); let i = index">

                    <div class="relative w-full">
                        <select
                                id="screen"
                                name="screen {{ i }}"
                                class="input-M peer w-64"
                                [(ngModel)]="v.screen"
                        >
                            <option value="" selected hidden></option>
                            <option value="Spot Varnish ink">Spot Varnish ink</option>
                            <option value="UV PO White">UV PO White</option>
                        </select>
                        <label class="label" for="screen">
                            Select Screen {{ i + 1 }}
                        </label>
                    </div>

                    <button
                            type="button"
                            class="h-10 w-10 flex items-center justify-center rounded
                            text-red-600 hover:bg-red-100"
                            (click)="removeScreen(i)"
                            *ngIf="screens().length > 1"
                            title="Delete finishing"
                    >
                        🗑️
                    </button>
                </div>
                <div class="flex justify-between items-center mt-4 mb-6">
                    <button
                            type="button"
                            class="button-blue"
                            (click)="addScreen()"
                    >
                        Add Screen
                    </button>
                </div>
            </ng-container>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div class="relative">
                    <select
                            id="coldFoil"
                            name="coldFoil"
                            class="input-M peer w-64"
                            [(ngModel)]="coldFoil"
                    >
                        <option value="" disabled selected hidden></option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <label class="label" for="coldFoil">
                        Cold Foil
                    </label>
                </div>

                <div class="relative">
                    <select
                            id="hotFoil"
                            name="hotFoil"
                            class="input-M peer w-64"
                            [(ngModel)]="hotFoil"
                    >
                        <option value="" disabled selected hidden></option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <label class="label" for="hotFoil">
                        Hot Foil
                    </label>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div class="relative">
                    <select
                            id="embossing"
                            name="embossing"
                            class="input-M peer w-64"
                            [(ngModel)]="embossing"
                    >
                        <option value="" disabled selected hidden></option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <label class="label" for="embossing">
                        Embossing
                    </label>
                </div>

                <div class="relative">
                    <select
                            id="lamination"
                            name="lamination"
                            class="input-M peer w-64"
                            [(ngModel)]="lamination"
                    >
                        <option value="" disabled selected hidden></option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <label class="label" for="lamination">
                        Lamination
                    </label>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div class="relative">
                    <input
                            id="dieCutCode"
                            type="text"
                            class="input-M peer w-64"
                            placeholder=" "
                            name="dieCutCode"
                            [(ngModel)]="dieCutCode"
                    />
                    <label class="label" for="dieCutCode">
                        Die Cut Code
                    </label>
                </div>
            </div>
            <button
                    type="button"
                    class="button-blue block ml-auto"
                    (click)="saveProductionData()"
            >
                {{ isEdit ? 'Update' : 'Save Product' }}
            </button>
        </div>
    </div>
</div>